module.exports = __webpack_public_path__ + "public/img/logo-ioa.424ae8d7.jpg";